(function() {
    let attempts = 0;
    const maxAttempts = 100; 
    
    const checkInterval = setInterval(() => {
        attempts++;
        
        if (window.tlFreeGiftOffer?.utils?.createAjaxCartErrorResponse) {
            clearInterval(checkInterval);
            
            const originalCreateError = window.tlFreeGiftOffer.utils.createAjaxCartErrorResponse;
            
            // Định nghĩa các câu dịch theo locale
            const translations = {
                // Polish (Mặc định)
                pl: (qty, title) => `Do jednego zamówienia możesz dodać maksymalnie 1 gratis.`, 
                
                // English
                en: (qty, title) => `You can add a maximum of one free product to an order.`,         
                
                // Greek
                el: (qty, title) => `Μπορείτε να προσθέσετε έως και ένα δωρεάν προϊόν στην παραγγελία σας.` 
            };
            
            window.tlFreeGiftOffer.utils.createAjaxCartErrorResponse = function(statusCode, errMessage) {
                try {
                    if (typeof errMessage === 'string' && errMessage.includes("You can't add more")) {
                        const match = errMessage.match(/You can't add more\s+(\d+)\s+(.+?)\s+to the cart/i);
                        
                        if (match) {
                            const qty = match[1];
                            const title = match[2];
                            
                            const locale = (window.Shopify?.locale || document.documentElement?.lang || 'pl')
                                .toLowerCase()
                                .split('-')[0];
                                
                            const translateFn = translations[locale] || translations['pl'];
                            errMessage = translateFn(qty, title);
                        }
                    }
                } catch (error) {
                    console.warn("TL Free Gift override translation error:", error);
                }
                
                return originalCreateError.call(this, statusCode, errMessage);
            };
        }
        
        if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
        }
    }, 100);
})();
